// AUTO GENERATED FILE - DO NOT EDIT
export default {
  analytics_billing_anomaly_page_section: 'Billing:Anomaly',
  analytics_billing_anomaly_quick_actions_page_name: 'Anomaly quick actions view',
  analytics_billing_auto_payment_quick_action_page_section: 'Billing: Auto Bill Payment Quick Action',
  analytics_billing_bill_breakdown_page_section: 'Billing: Bill Breakdown',
  analytics_billing_bill_details_page_name: 'Billing:BillDetails',
  analytics_billing_bill_details_page_section: 'Billing:BillDetails',
  analytics_billing_button_event_category: 'Button',
  analytics_billing_current_bill_page_section: 'Billing:Current Bill',
  analytics_billing_dashboard_next_bill_page_section: 'Dashboard:NextBill',
  analytics_billing_dashboard_page_name: 'Dashboard',
  analytics_billing_event_action_click: 'OnClick',
  analytics_billing_event_action_key: 'event_action',
  analytics_billing_event_bill_detail_page_3rd_level: 'Bill detail page (3rd level)',
  analytics_billing_event_bill_page_first_bill: 'Bill page / first bill',
  analytics_billing_event_bill_page_no_bills: 'Bill page / no bills',
  analytics_billing_event_bill_page_second_bill: 'Bill page / second bill',
  analytics_billing_event_bill_page_second_level: 'Billing page (2nd level)',
  analytics_billing_event_category_card: 'Card',
  analytics_billing_event_category_key: 'event_category',
  analytics_billing_event_dashboard_negative_bill: 'Dashboard negative bill',
  analytics_billing_event_dashboard_no_bills: 'Dashboard / no bills',
  analytics_billing_event_due_3rd_level: '3rd level / Due',
  analytics_billing_event_entry_point: 'Billing entry point',
  analytics_billing_event_info_popup: 'Info pop-up',
  analytics_billing_event_label_auto_bill_payment: 'Set up auto bill payment',
  analytics_billing_event_label_close: 'Close',
  analytics_billing_event_label_information: 'Information',
  analytics_billing_event_label_key: 'event_label',
  analytics_billing_event_label_next_bill: 'Next Bill',
  analytics_billing_event_paid_3rd_level: '3rd level / Paid',
  analytics_billing_event_partially_paid_3rd_level: '3rd level / Partially paid bill',
  analytics_billing_event_payment_processing_3rd_level: '3rd level / Payment Processing',
  analytics_billing_event_scroll_page_2nd_level: '(Scroll)- Billing page (2nd level)',
  analytics_billing_event_scrolled_bill_detail_page: '(Scrolled) - Bill detail page',
  analytics_billing_event_ui_interaction_key: 'ui_interaction',
  analytics_billing_event_unpaid_bill_3rd_level: '3rd level / Unpaid bill',
  analytics_billing_journey_type: 'Billing',
  analytics_billing_journey_type_key: 'journey_type',
  analytics_billing_logged_in: 'logged in',
  analytics_billing_my_bill_page_name: 'My Bill',
  analytics_billing_my_bills_page_name: 'MyBills',
  analytics_billing_my_bills_page_section: 'Billing:My Bills',
  analytics_billing_negative_bill_quick_action_page_section: 'Billing:Negative Bill Quick Action',
  analytics_billing_page_name: 'Billing',
  analytics_billing_page_name_key: 'page_name',
  analytics_billing_page_section: 'billing; %1$s',
  analytics_billing_page_section_billing: 'Billing',
  analytics_billing_page_section_key: 'page_section',
  analytics_billing_page_view_key: 'page_view',
  analytics_billing_tile_event_category: 'Tile',
  analytics_billing_transaction_status_key: 'transaction_status',
  analytics_billing_visitor_bill_amount_current_active_key: 'visitor_bill_amount_current_active',
  analytics_billing_visitor_bill_date_due_current_active_key: 'visitor_bill_date_due_current_active',
  analytics_billing_visitor_login_status_key: 'visitor_login_status',
  billing_account_lines_banner_list_default_selection: 'All lines',
  billing_account_lines_banner_subtitle: 'Choose from the below account line',
  billing_account_lines_banner_title: 'Lines',
  billing_account_lines_picker_cancel: 'Cancel',
  billing_account_lines_picker_done: 'Done',
  billing_additional_review_card_button: 'Review',
  billing_additional_review_card_title: 'Safe pocket invoice',
  billing_auto_bill_banner_description_off: 'Your bill will be paid at the %1$s of each month. Your auto payment is off right now.',
  billing_auto_bill_banner_description_on: 'Your bill will be paid at the %1$s of each month. Next payment in %2$s days.',
  billing_auto_bill_banner_description_on_one_day: 'Your bill will be paid at the %1$s of each month. Next payment in %2$s day.',
  billing_auto_bill_banner_edit_button: 'Edit auto bill payment',
  billing_auto_bill_banner_title_off: 'Auto bill payment is off',
  billing_auto_bill_banner_title_on: 'Auto bill payment is on',
  billing_bill_number: 'Bill number',
  billing_breakdown_filter_one_off_purchases_text: 'One-off purchases',
  billing_breakdown_filter_out_of_plan_text: 'Out of plan',
  billing_breakdown_filter_products_text: 'Products',
  billing_breakdown_filter_users_text: 'Users',
  billing_breakdown_list: 'List',
  billing_card_tag_paid: 'Paid',
  billing_card_tag_partially_paid: 'Partially paid',
  billing_card_tag_processing_payment: 'Processing payment',
  billing_card_tag_unpaid: 'Unpaid',
  billing_chart_error_text: 'An error has occurred and we’re having some trouble loading your content.',
  billing_chart_error_try_again_button: 'Try again',
  billing_chart_see_bill: 'See bill',
  billing_chart_unavailable_bill: 'No bill',
  billing_client_code: 'Client code',
  billing_client_status: 'Status',
  billing_credit_card_already_paid: 'Paid on %1$s',
  billing_credit_card_paid_date: 'To be paid the %1$s%2$s %3$s',
  billing_credit_card_pay_by_date: 'Pay by %1$s',
  billing_credit_card_pay_now: 'Pay now %1$s',
  billing_credit_card_stars: '%1$s **** %2$s',
  billing_current_bill_auto_bill_pay: 'Auto bill payment on %1$s %2$s',
  billing_current_bill_auto_pay: 'Auto payment %1$s %2$s',
  billing_current_bill_error_text: 'An error has occurred and we’re having some trouble loading your content.',
  billing_current_bill_error_try_again_button: 'Try again',
  billing_current_bill_extra_charges: 'Extra charges included',
  billing_current_bill_included_services: 'Your services included',
  billing_current_bill_line_status: 'Line status:',
  billing_current_bill_title: 'Current bill',
  billing_current_spend: 'current spend',
  billing_cvm_banner_description: 'Stop worrying about your bill payment. Set up auto bill payment now.',
  billing_cvm_banner_setup_button: 'Set up auto bill payment',
  billing_cvm_banner_title: 'Auto bill payment',
  billing_dashboard_access_secure_content_subtitle: 'Tap to access this secure area',
  billing_dashboard_current_spend: 'Current spend',
  billing_dashboard_description: 'Your current spend is:',
  billing_dashboard_due_date_args: 'To be paid the %1$s%2$s',
  billing_dashboard_due_in_days: 'Due in %1$s days',
  billing_dashboard_due_now: 'Due now',
  billing_dashboard_next_available_date: 'Your bill will be available on %1$s',
  billing_dashboard_no_bill_description: 'Not available yet.',
  billing_dashboard_paid_title: 'The bill has been paid',
  billing_dashboard_title: 'Next bill',
  billing_dashboard_unpaid_title: 'Pay the bill',
  billing_dashboard_view_bill: 'View',
  billing_details_bill_paid: 'Bill paid',
  billing_details_bundle: 'Bundle',
  billing_details_call_to: 'Call to',
  billing_details_call_to_min: 'min',
  billing_details_call_to_sec: 'sec',
  billing_details_card_title: 'Bill details',
  billing_details_closure_date: 'Bill closure date',
  billing_details_due_date: 'Due date',
  billing_details_issue_date: 'Issue date',
  billing_details_more_info: 'Details',
  billing_details_national_call: 'National Call',
  billing_details_out_of_tariff_title: 'Out of tariff',
  billing_details_partially_paid_remaining: 'You have paid %1$s (%2$s remaining)',
  billing_details_pay_amount_left: 'Pay amount left',
  billing_details_pay_bill_now: 'Pay bill now',
  billing_details_pdf_report: 'PDF report',
  billing_details_title: '%1$s bill',
  billing_details_total_spend: 'total spend',
  billing_download_pdf_button: 'Download as PDF',
  billing_error_something_went_wrong: 'Something went wrong…',
  billing_expensive_question_text: 'Why is my invoice different from previous months?',
  billing_expensive_quick_action_question_button_text: 'Close',
  billing_expensive_quick_action_question_description_text: 'The charges in this field are included in your total invoice amount. You can view all your pricing details in the ‘Invoice Details’ section below.',
  billing_expensive_quick_action_question_text: 'Why is my bill different this month?',
  billing_expensive_quick_action_title: 'Billing Note',
  billing_expensive_quick_action_total_text: 'Total',
  billing_expensive_quick_action_view_button_text: 'View',
  billing_filter_out_of_plan: 'Out of plan',
  billing_filter_products: 'Products',
  billing_filter_see_all: 'See all',
  billing_filter_users: 'Users',
  billing_history_screen_error: 'An error has occurred and we’re having some trouble loading your content.',
  billing_history_screen_try_again: 'Try again',
  billing_landing_title: 'My bills',
  billing_negative_bill_quick_action_button_text: 'Close',
  billing_negative_bill_quick_action_description: 'A negative bill indicates that your account was charged with enough money to cover the current bill and still have some balance left.',
  billing_negative_bill_quick_action_question_text: 'Why my bill balance is negative?',
  billing_negative_bill_quick_action_title: 'Negative balance',
  billing_negative_over_paid: 'Over paid bill',
  billing_negative_value_note: 'Negative balance',
  billing_no_bill_subtitle: 'Your bill will be available on %1$s.',
  billing_no_bill_title: 'Your first bill isn’t ready yet.',
  billing_payment_breakdown_btn_hide_details: 'Show less',
  billing_payment_breakdown_btn_less: 'Show less',
  billing_payment_breakdown_btn_more: 'Show more',
  billing_payment_breakdown_btn_show_details: 'Show more',
  billing_payment_breakdown_error_text: 'An error has occurred and we’re having some trouble loading your content.',
  billing_payment_breakdown_error_try_again_button: 'Try again',
  billing_payment_breakdown_service_cost_title: 'Out of service cost',
  billing_payment_breakdown_title: 'Bill breakdown',
  billing_payment_breakdown_total_before_vat_title: 'Total before taxes',
  billing_payment_breakdown_total_pay_title: 'Total to pay',
  billing_payment_breakdown_total_title: 'Total',
  billing_payment_breakdown_vat_title: 'VAT',
  billing_payment_info_billing_date: 'Billing date',
  billing_payment_info_pay_by: 'Pay by',
  billing_payment_info_payment_received: 'Payment received',
  billing_payment_info_to_be_paid: 'To be paid on %1$s',
  billing_payment_method: 'Payment method',
  billing_payment_method_error_text: 'An error has occurred and we’re having some trouble loading your content.',
  billing_payment_method_error_try_again_button: 'Try again',
  billing_payment_method_not_saved: 'No payment saved',
  billing_pie_chart: 'Chart view',
  billing_postpone_payment_cancel_button: 'Cancel',
  billing_postpone_payment_current_bill: 'Your current bill is',
  billing_postpone_payment_error_text: 'Please start your postpone process again',
  billing_postpone_payment_error_title: 'Something went wrong',
  billing_postpone_payment_loading: 'Loading',
  billing_postpone_payment_postpone_button: 'Postpone',
  billing_postpone_payment_return_button: 'Please start your postpone process again',
  billing_postpone_payment_success_text: 'The payment of this bill has been completed successfully.',
  billing_postpone_payment_success_title: 'Bill payment postponed',
  billing_postpone_payment_title: 'Postpone bill payment',
  billing_previous_bill_error_text: 'An error has occurred and we’re having some trouble loading your content.',
  billing_previous_bill_error_try_again_button: 'Try again',
  billing_previous_bill_title: 'Previous bills',
  billing_review_installment_plan_details_title: 'Monthly instalment',
  billing_review_installment_plan_fee_title: 'Fee',
  billing_review_installment_plan_first_payment_date_title: 'First payment date',
  billing_review_installment_plan_monthly_installment_card_amount_per_month: '/month',
  billing_review_installment_plan_number_of_installments_title: 'Number of instalments',
  billing_review_installment_plan_payment_date_desc: 'Added to monthly bill (%1$s)',
  billing_review_installment_plan_payment_date_title: 'Payment date',
  billing_review_installment_plan_primary_button_title: 'Confirm',
  billing_review_installment_plan_secondary_button_title: 'View agreement',
  billing_review_installment_plan_total_title: 'Total',
  billing_save_current_bill_pdf_button: 'Save as PDF',
  billing_setup_installment_plan_button: 'Set up installment plan',
  billing_setup_installment_plan_duration_card_subtitle: '%1$s/month',
  billing_setup_installment_plan_duration_card_title: '%1$s months',
  billing_setup_installment_plan_duration_title: 'Choose duration',
  billing_setup_installment_plan_payment_header: 'Payment options',
  billing_setup_installment_plan_payment_title: 'Add to monthly bill (%1$s)',
  billing_setup_installment_plan_primary_button_title: 'Review',
  billing_setup_installment_plan_screen_header: 'Total amount owed:',
  billing_setup_installment_plan_screen_title: 'Instalment plan setup',
  billing_setup_installment_plan_secondary_button_title: 'Cancel',
  billing_show_more_title: 'Show next %1$s months',
  billing_success_installment_plan_description: 'Your first payment will be paid in %1$s\'s bill on %2$s.',
  billing_success_installment_plan_message: 'Instalment plan set up!',
  billing_success_installment_primary_button_title: 'Return to My bills',
  billing_success_installment_secondary_button_title: 'Email me the agreement',
  billing_tile_error_text: 'An error has occurred',
  billing_warning_banner_description_one_unpaid_bill: 'Your unpaid bill has been added to %1$s’s bill.',
  billing_warning_banner_description_unpaid_bills: 'Your unpaid bills have been added to %1$s’s bill.',
  billing_warning_banner_payment_button: 'See repayment options',
  billing_warning_banner_title_one_unpaid_bill: '1 bill payment missed',
  billing_warning_banner_title_unpaid_bills: '%1$s bills payment missed',
  soho_billing_payment_breakdown_categories: 'Categories',
  soho_billing_payment_breakdown_categories_card_all_services_included: 'All services included',
  soho_billing_payment_breakdown_categories_card_month_year: '%1$s, %2$s',
  soho_billing_payment_breakdown_categories_card_services_count: '%1$s services',
  soho_billing_payment_breakdown_categories_card_title: 'Your month',
  soho_billing_payment_breakdown_categories_show_less: 'Show less',
  soho_billing_payment_breakdown_categories_show_more: 'Show more',
  soho_billing_payment_breakdown_chart_card_title: 'Your month',
  soho_billing_payment_breakdown_chart_show_less: 'Show less',
  soho_billing_payment_breakdown_chart_show_more: 'Show more',
  soho_billing_payment_breakdown_list: 'List view',
  soho_billing_price_per_month: 'Price per month',
  billing_current_bills_title: 'Current bills'
}
